var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCupAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 5.5C5 5.22386 5.22386 5 5.5 5H18.5C18.7761 5 19 5.22386 19 5.5V7.25H19.5C21.2949 7.25 22.75 8.70507 22.75 10.5C22.75 12.2949 21.2949 13.75 19.5 13.75H17.9118C16.67 15.7037 14.4864 17 12 17C8.13401 17 5 13.866 5 10V5.5ZM18.6305 12.25H19.5C20.4665 12.25 21.25 11.4665 21.25 10.5C21.25 9.5335 20.4665 8.75 19.5 8.75H19V10C19 10.7871 18.8701 11.5439 18.6305 12.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17H21.3333C21.7015 17 22 17.2985 22 17.6667C22 18.403 21.403 19 20.6667 19H3.33333C2.59695 19 2 18.403 2 17.6667C2 17.2985 2.29848 17 2.66667 17H12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCupAlt);
export default __webpack_public_path__ + "static/media/cup-alt.6e450eee4fa962d691a5589964779483.svg";
export { ForwardRef as ReactComponent };